import React, { Suspense, useEffect } from 'react';
import { useAuthStore } from '../shared/auth';
import { useThemeColors } from '../shared/theme';
import { AuthStackNavigator } from './AuthStack';
import { MainStackNavigator } from './MainStack';
import { NavigationScreenLoader } from './NavigationScreenLoader';
import { IssueReportErrorBoundary } from '../components/IssueReportErrorBoundary';
import { ActionSheetHost } from '../components/common/ActionSheetHost';
import { flushPendingAuthRootReset } from './navigationRootRef';

export type {
  AppRootParamList,
  AuthStackParamList,
  MainStackParamList,
  RootStackParamList,
  TabParamList,
} from './types';

/** Swap Auth vs Main stack when session changes. */
export const AppNavigator = () => {
  const is_authenticated = useAuthStore(state => state.isAuthenticated);
  const colors = useThemeColors();

  /** After Auth↔Main remount, flush any queued home RESET once the target routes exist. */
  useEffect(() => {
    flushPendingAuthRootReset();
  }, [is_authenticated]);

  if (!colors) {
    return <NavigationScreenLoader />;
  }

  const boundary_name = is_authenticated ? 'MainStack' : 'AuthStack';
  /** Key forces a clean remount — Auth/Main share route names (e.g. GuestMenuPreview). */
  const stack = !is_authenticated ? (
    <AuthStackNavigator key="auth" />
  ) : (
    <MainStackNavigator key="main" />
  );
  const stack_content = (
    <Suspense fallback={<NavigationScreenLoader />}>{stack}</Suspense>
  );

  return (
    <IssueReportErrorBoundary name={boundary_name}>
      {stack_content}
      <ActionSheetHost />
    </IssueReportErrorBoundary>
  );
};

export default AppNavigator;
